var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNaviCustomerManagement(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.25 0.5C9.32107 0.5 11 2.17893 11 4.25C11 6.32107 9.32107 8 7.25 8C5.17893 8 3.5 6.32107 3.5 4.25C3.5 2.17893 5.17893 0.5 7.25 0.5ZM9.5 4.25C9.5 3.00736 8.49264 2 7.25 2C6.00736 2 5 3.00736 5 4.25C5 5.49264 6.00736 6.5 7.25 6.5C8.49264 6.5 9.5 5.49264 9.5 4.25Z",
    fill: "#113252"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.25 9.5C12.3211 9.5 14 11.1789 14 13.25C14 15.3211 12.3211 17 10.25 17H4.25C2.17893 17 0.5 15.3211 0.5 13.25C0.5 11.1789 2.17893 9.5 4.25 9.5H10.25ZM12.5 13.25C12.5 12.0074 11.4926 11 10.25 11H4.25C3.00736 11 2 12.0074 2 13.25C2 14.4926 3.00736 15.5 4.25 15.5H10.25C11.4926 15.5 12.5 14.4926 12.5 13.25Z",
    fill: "#113252"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4979 6.88865C11.6556 6.63527 11.9515 6.5 12.25 6.5C13.4926 6.5 14.5 5.49264 14.5 4.25C14.5 3.00736 13.4926 2 12.25 2C11.9515 2 11.6556 1.86473 11.4979 1.61135C11.4909 1.60014 11.4839 1.58896 11.4768 1.57782C11.2142 1.16331 11.3473 0.576401 11.835 0.522703C11.9713 0.507701 12.1097 0.5 12.25 0.5C14.3211 0.5 16 2.17893 16 4.25C16 6.32107 14.3211 8 12.25 8C12.1097 8 11.9713 7.9923 11.835 7.9773C11.3473 7.9236 11.2142 7.33669 11.4768 6.92218C11.4839 6.91104 11.4909 6.89986 11.4979 6.88865Z",
    fill: "#113252"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5417 14.8169C14.6552 14.6275 14.8556 14.5 15.0764 14.5H15.25C16.4926 14.5 17.5 13.4926 17.5 12.25C17.5 11.0074 16.4926 10 15.25 10H15.0764C14.8556 10 14.6552 9.87252 14.5417 9.68313C14.2646 9.22082 14.5653 8.5 15.1043 8.5H15.25C17.3211 8.5 19 10.1789 19 12.25C19 14.3211 17.3211 16 15.25 16H15.1043C14.5653 16 14.2646 15.2792 14.5417 14.8169Z",
    fill: "#113252"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNaviCustomerManagement);
export default __webpack_public_path__ + "static/media/naviCustomerManagement.8f0f4f810c9303b7c2ca471048751464.svg";
export { ForwardRef as ReactComponent };